import * as Api from '@ViewModels';
import { Provider, inject } from 'mobx-react';
import * as React from 'react';
import { useLocation } from 'react-router';
import {
	IImpersonationContextComponentProps,
	ILocationState,
	IModalContext,
	ModalChildComponentContextKey,
} from '../../../../models';
import { ImpersonationContextViewModel } from '../../../../viewmodels/AdminViewModels';
import { ApprovalPreviewSocialMediaPost } from '../../../../web/containers/socialMediaPostApproval/ApprovalPreviewSocialMediaPost';

interface IPostProps extends IModalContext {
	routeContainerClassName: string;
}

const AdminPreviewSocialMediaPostBase: React.FC<IPostProps> = ({ parentModal, routeContainerClassName }) => {
	const loc = useLocation<ILocationState<Api.SocialMediaPostReportViewModel, any>>();
	const impersonationProviderProps = React.useRef<IImpersonationContextComponentProps>({
		impersonationContext: new ImpersonationContextViewModel(
			loc.state?.viewModel?.impersonationContext ?? loc.state?.model?.impersonationContext
		),
	}).current;
	const onPostUpdated = () => {
		parentModal?.onRequestClose?.();
		return true;
	};

	return (
		<Provider {...impersonationProviderProps}>
			<ApprovalPreviewSocialMediaPost onPostUpdated={onPostUpdated} routeContainerClassName={routeContainerClassName} />
		</Provider>
	);
};

export const AdminPreviewSocialMediaPost = inject(ModalChildComponentContextKey)(AdminPreviewSocialMediaPostBase);
